import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { ChangedFieldsCell as GenericChangedFieldsCell } from '@/modules/common/components/changed-fields';

import { ProjectChangedField } from '../../types/project-changes';
import { createProjectChangedFieldsStrategy } from './project-changed-fields.strategy';

interface ChangedFieldsCellProps {
  changedFields: ProjectChangedField[];
}

/**
 * Project-specific "Changed Fields" cell. Thin wrapper that feeds the project
 * field list and strategy into the shared generic cell.
 */
export const ChangedFieldsCell = ({ changedFields }: ChangedFieldsCellProps) => {
  // Subscribe to i18n so the memoized strategy rebuilds on language change.
  const { i18n } = useTranslation('authenticated.projects');
  const strategy = useMemo(() => createProjectChangedFieldsStrategy(), [i18n.language]);

  return <GenericChangedFieldsCell fields={changedFields} strategy={strategy} />;
};
